import { Link } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import SectionHeader from "@/components/feature/SectionHeader";

const values = [
  { icon: "ri-vip-diamond-line", title: "品质至上", desc: "每一部上架作品都经过严格筛选，尊享漫画、钻石漫画等专属内容以品质为先，绝不以量取胜。" },
  { icon: "ri-vip-crown-line", title: "尊贵体验", desc: "专注服务高端漫画读者，以豪华画质、纯净阅读与专属特权，营造无与伦比的贵族阅读氛围。" },
  { icon: "ri-flashlight-line", title: "极速更新", desc: "紧跟热门作品更新节奏，让每一位会员第一时间读到最新章节，不错过任何精彩瞬间。" },
  { icon: "ri-heart-line", title: "用户为本", desc: "倾听每一位读者的声音，持续打磨内容与体验，让土豪漫画网成为读者真正信赖的专属漫画家园。" },
];

const steps = [
  { num: "01", title: "始于热爱", desc: "源于对高品质漫画的执着追求，希望为懂漫画、爱漫画的读者打造一个真正尊贵的阅读空间。" },
  { num: "02", title: "臻于品质", desc: "建立严格的选品与画质标准，汇聚尊享、钻石、贵族、豪华四大专属内容专区。" },
  { num: "03", title: "成于体验", desc: "围绕专属特权阅读打造完整服务体系，让每一次翻页都是尊贵的享受。" },
];

function AboutPage() {
  return (
    <Layout
      title="关于我们-品牌介绍|发展理念|土豪漫画网"
      description="了解土豪漫画网：我们专注尊享漫画、钻石漫画、贵族漫画、豪华漫画等专属内容，坚持品质至上、尊贵体验、极速更新、用户为本，为高端读者打造专属特权阅读平台。"
    >
      <section className="relative overflow-hidden pt-28 md:pt-36 pb-10">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-b from-primary-900/25 via-background-950 to-background-950"></div>
          <div className="absolute -right-20 top-8 h-72 w-72 rounded-full bg-primary-500/10 blur-3xl"></div>
        </div>
        <div className="relative mx-auto max-w-7xl px-4 md:px-6">
          <nav className="text-xs text-foreground-500" aria-label="面包屑">
            <ol className="flex items-center gap-2">
              <li><Link to="/" className="hover:text-primary-300">首页</Link></li>
              <li><i className="ri-arrow-right-s-line"></i></li>
              <li className="text-primary-300">关于我们</li>
            </ol>
          </nav>
          <h1 className="mt-5 font-heading text-3xl font-black text-foreground-50 md:text-5xl">
            关于<span className="text-gold-grad">土豪漫画网</span>
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-7 text-foreground-400 md:text-base">
            一家专注高品质漫画的专属阅读平台，为尊贵读者提供尊享漫画、钻石漫画、贵族漫画、豪华漫画等专属内容与特权阅读体验。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 md:px-6 py-6 md:py-12">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-3xl">我们的品牌故事</h2>
            <p className="mt-5 text-sm leading-8 text-foreground-400 md:text-base">
              土豪漫画网诞生于一群对漫画品质有着苛刻要求的创作者与读者之中。我们始终相信，好的漫画值得被更认真地对待——更清晰的画质、更快的更新、更纯粹的空间。
            </p>
            <p className="mt-4 text-sm leading-8 text-foreground-400 md:text-base">
              为此，我们创立了尊享漫画、钻石漫画、贵族漫画、豪华漫画四大专属专区，以严格的标准甄选每一部作品，并以会员专属特权阅读的方式，回馈每一位珍视品质的读者。
            </p>
            <p className="mt-4 text-sm leading-8 text-foreground-400 md:text-base">
              我们不做大而全的杂货铺，只做小而精的专属殿堂。让每一个进入土豪漫画网的读者，都能感受到一份属于贵族的从容与尊贵。
            </p>
          </div>
          <div className="relative overflow-hidden rounded-xl border border-primary-500/30">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20luxury%20reading%20scene%20with%20golden%20decorative%20elements%2C%20elegant%20gold%20and%20deep%20black%20palette%2C%20floating%20comic%20book%20pages%20and%20gold%20light%20particles%2C%20premium%20magazine%20style%20illustration%2C%20majestic%20and%20refined&width=1200&height=800&seq=about-tuhao&orientation=landscape"
              alt="土豪漫画网尊贵专属阅读品牌故事"
              className="aspect-[3/2] w-full object-cover object-top"
            />
          </div>
        </div>
      </section>

      <section className="border-t border-background-800 bg-background-900/40 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <SectionHeader
            eyebrow="Development Path"
            title="发展理念"
            desc="从品质到体验，一步一个脚印，打造值得托付的专属漫画平台。"
            align="center"
          />
          <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
            {steps.map((s) => (
              <div key={s.num} className="relative rounded-lg border border-background-800 bg-background-950 p-7">
                <span className="font-heading text-4xl font-black text-primary-500/25">{s.num}</span>
                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-50">{s.title}</h3>
                <p className="mt-3 text-sm leading-7 text-foreground-400">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <SectionHeader eyebrow="Core Values" title="我们的内容原则" align="center" />
        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((v) => (
            <div key={v.title} className="rounded-lg border border-background-800 bg-background-900/60 p-7 transition hover:border-primary-500/40 hover:-translate-y-1">
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-accent-500 text-xl text-foreground-950">
                <i className={v.icon}></i>
              </span>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-50">{v.title}</h3>
              <p className="mt-3 text-sm leading-7 text-foreground-400">{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 md:px-6 pb-16">
        <div className="rounded-xl border border-primary-500/30 bg-gradient-to-br from-primary-500/10 to-transparent p-8 md:p-12 text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
            期待与你相遇，共赴<span className="text-gold-grad">尊贵阅读之旅</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-7 text-foreground-400 md:text-base">
            如有任何问题或合作意向，欢迎通过常见问题页或联系客服与我们取得联系。客服邮箱：service@tuhao-manga.example.com
          </p>
          <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
            <Link
              to="/category"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-gradient-to-r from-primary-500 to-accent-500 px-7 py-3 text-sm font-semibold text-foreground-950 transition hover:from-primary-400 hover:to-accent-400 cursor-pointer"
            >
              浏览尊享专区
            </Link>
            <Link
              to="/vip"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-500/50 px-7 py-3 text-sm font-semibold text-primary-300 transition hover:bg-primary-500/10 cursor-pointer"
            >
              开通会员特权
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default AboutPage;